/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * TASCO
 * OpenAPI spec version: 1.0.0
 */
import {createInstance} from "@shared/api/axios";

export const stt = (formData: FormData) =>
  createInstance({
    url: '/v1/voice-bot/stt',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const classifyIntent = (data: any) =>
  createInstance({
    url: '/v1/voice-bot/classify-intent',
    method: 'POST',
    data,
  });

export const getNewsAudioList = (params: { page: number; page_size: number; category?: string }) =>
  createInstance({
    url: '/v1/voice-bot/news-audio/list',
    method: 'GET',
    params,
  });

export const getNewsSummary = (params: { category?: string }) =>
  createInstance({
    url: '/v1/voice-bot/news-audio/summary',
    method: 'GET',
    params,
  });

export const getRouteFromCoordsToAddress = (params: {
  origin: string;
  destination_address: string;
  vehicle?: string;
  points_encoded?: boolean;
}) =>
  createInstance({
    url: '/v1/voice-bot/route/coords-to-address',
    method: 'GET',
    params,
  });

export const geocodeSearch = (data: {
  address: string;
}) =>
  createInstance({
    url: '/v1/voice-bot/geocode/search',
    method: 'POST',
    data,
  });

export const agentAction = (formData: FormData) =>
  createInstance({
    url: '/v1/agent-bot/action',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getTTSWebSocket = () => {
  const baseUrl = import.meta.env.VITE_BACKEND_URL?.replace(/^https?/, (protocol) =>
    protocol === 'https' ? 'wss' : 'ws',
  );
  const wsUrl = `${baseUrl}/v1/voice-bot/ws`;
  return new WebSocket(wsUrl);
};
